import React from "react";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {
    IFreePlayVoucherViewModel
} from "../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardBackBox} from "../../../boxes/voucher-card/back/voucher-card-back.box";
import {VoucherCardBackHeaderBox} from "../../../boxes/voucher-card/back/header/voucher-card-back-header.box";
import {VoucherCardBackContentBox} from "../../../boxes/voucher-card/back/content/voucher-card-back-content.box";
import {VoucherCardBackFooterBox} from "../../../boxes/voucher-card/back/footer/voucher-card-back-footer.box";
import {observer} from "mobx-react";
import {
    VoucherCardSideToggleButtonBox
} from "../../../boxes/voucher-card/common/footer/side-toggle/voucher-card-side-toggle-button.box";
import {
    VoucherCardSideFooterContentBox
} from "../../../boxes/voucher-card/common/footer/footer-content/voucher-card-side-footer-content.box";
import { SvgSizeUnit } from "../../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {CyClass} from "../../../../../../common/cy-classes";

interface VoucherCardBackComponentProps {
    voucher: IFreePlayVoucherViewModel;
    onToggleSide: () => void;
    onClick?: () => void;
    backSideShown: boolean;
    backgroundImageUrl: string;
}

@observer
export class VoucherCardBackComponent extends OrbitComponent<VoucherCardBackComponentProps> {
    render() {
        let CloseIcon = this.services.theme.currentTheme.icons.closeIcon;
        return (
            <VoucherCardBackBox backgroundImageUrl={this.props.backgroundImageUrl} backSideShown={this.props.backSideShown} className={CyClass('cy-voucher-card-back')}>
                <VoucherCardBackHeaderBox onClick={this.props.onClick}>
                    {this.props.voucher.voucherName}
                </VoucherCardBackHeaderBox>
                <VoucherCardBackContentBox onClick={this.props.onClick}>
                    {this.props.voucher.voucherDescription}
                </VoucherCardBackContentBox>
                <VoucherCardBackFooterBox>
                    <VoucherCardSideToggleButtonBox onClick={this.props.onToggleSide}>
                        <CloseIcon size={1.4} sizeUnit={SvgSizeUnit.Rem} />
                    </VoucherCardSideToggleButtonBox>
                    <VoucherCardSideFooterContentBox onClick={this.props.onClick}/>
                </VoucherCardBackFooterBox>
            </VoucherCardBackBox>
        );
    }
}

